// src/Dashboard/pages/teacher/SuiviCompetitions/components/CompetitionRegisteredAdherentCard.jsx

import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { FaWeightHanging, FaUserTie } from "react-icons/fa";

import {
  formatWeight,
  getAdherentCompetitionCategories,
  getAdherentName,
  getAdherentPhoto,
  getBirthYear,
  isCoachForEvent,
} from "../utils/suiviCompetitionsUtils";

export default function CompetitionRegisteredAdherentCard({
  adherent,
  enseignants = [],
  onClick,
}) {
  const photo = getAdherentPhoto(adherent);
  const name = getAdherentName(adherent);
  const isCoach = isCoachForEvent(adherent, enseignants);

  const birthYear = getBirthYear(adherent?.date_naissance);
  const weight = formatWeight(adherent?.poids);

  const { ageCategory, weightCategory } =
    getAdherentCompetitionCategories(adherent);

  return (
    <article
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => event.key === "Enter" && onClick?.()}
      title="Cliquer pour saisir les résultats"
      className="group overflow-hidden rounded-2xl bg-white shadow ring-1 ring-slate-200/70 transition hover:-translate-y-0.5 hover:shadow-lg dark:bg-slate-900/70 dark:ring-slate-700/70"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-slate-100 dark:bg-slate-800">
        <img
          src={photo}
          alt={name}
          className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
          draggable={false}
          onError={(event) => {
            event.currentTarget.src = "/img/user_avatar.jpg";
          }}
        />

        <div className="absolute left-2 top-2 flex flex-col gap-1.5">
          {isCoach ? (
            <span className="inline-flex items-center gap-1 rounded-full bg-red-600 px-2.5 py-1 text-[11px] font-bold text-white shadow ring-2 ring-white/70">
              <FaUserTie />
              Coach
            </span>
          ) : (
            <span className="inline-flex rounded-full bg-blue-600 px-2.5 py-1 text-[11px] font-bold text-white shadow ring-2 ring-white/70">
              {ageCategory || "Catégorie"}
            </span>
          )}
        </div>

        {birthYear && (
          <div className="absolute right-2 top-2">
            <span className="inline-flex items-center gap-1 rounded-full bg-white/95 px-2.5 py-1 text-[11px] font-bold text-slate-900 shadow ring-1 ring-white/80 dark:bg-slate-950/90 dark:text-white dark:ring-slate-700">
              <FaCalendarAlt />
              {birthYear}
            </span>
          </div>
        )}

        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-950/95 via-slate-950/45 to-transparent p-3 pt-12">
          <p className="line-clamp-1 text-sm font-bold text-white">{name}</p>
        </div>
      </div>

      {!isCoach && (
        <div className="space-y-2 p-3">
          <div className="grid grid-cols-1 gap-2">
            <div className="flex items-center justify-between gap-2 rounded-xl bg-slate-50 px-3 py-2 ring-1 ring-slate-200 dark:bg-slate-800/60 dark:ring-slate-700">
              <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                <FaWeightHanging />
                Poids
              </span>

              <span className="text-xs font-bold text-slate-900 dark:text-white">
                {weight}
              </span>
            </div>

            <div className="flex items-center justify-between gap-2 rounded-xl bg-emerald-50 px-3 py-2 ring-1 ring-emerald-200 dark:bg-emerald-900/20 dark:ring-emerald-800/60">
              <span className="text-[11px] font-bold uppercase tracking-wide text-emerald-700 dark:text-emerald-200">
                Cat. poids
              </span>

              <span className="text-xs font-bold text-emerald-800 dark:text-emerald-100">
                {weightCategory || "—"}
              </span>
            </div>
          </div>
        </div>
      )}
    </article>
  );
}